import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  emptyDateSubconditionState,
  numCustomerReturnsFromModel,
  validateNumCustomerReturnsCondition,
  type NumCustomerReturnsState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";
import {
  getDateSubconditionSuffix,
  toModelDateSubcondition,
} from "./date-subcondition";

export const NUM_CUSTOMER_RETURNS = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<NumCustomerReturnsState>
  >,
): ConditionType<NumCustomerReturnsState, Condition.NumCustomerReturns> => ({
  name: "Number of previous customer returns",
  description(state) {
    if (!state.returnOption) {
      return "The total number of returns this customer has made across all their orders";
    }

    let description = `Total customer returns across all orders ${state.returnOption.toLowerCase()} ${state.numReturns}`;

    // Add date subcondition suffix from shared helper
    description += getDateSubconditionSuffix(state.dateSubcondition);

    return description;
  },
  Details(props: ConditionTypeDetailsProps<NumCustomerReturnsState>) {
    return React.createElement(Details, props);
  },
  empty: {
    numReturns: (0).toFixed(0),
    returnOption: null,
    dateSubcondition: emptyDateSubconditionState,
  },
  fromModel(model) {
    return numCustomerReturnsFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.NUM_CUSTOMER_RETURNS,
      numReturns: +state.numReturns,
      numReturnsOption: state.returnOption,
      // Use only dateSubcondition going forward
      dateSubcondition: toModelDateSubcondition(state.dateSubcondition),
    };
  },
  valid(state) {
    return validateNumCustomerReturnsCondition(state).valid;
  },
});

export { type NumCustomerReturnsState } from "@redotech/redo-model/return-flow/condition-validate";
